export function LoadingState() {
  return <p className="text-foreground">Loading...</p>;
}
